import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "inline-descriptor-wrapper" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "fmenu__scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "container",
      class: "inline-descriptor",
      style: _normalizeStyle(_ctx.isTable ? 'display: contents;' : 'display: inline;'),
      id: 'contid' + _ctx.id
    }, null, 12, _hoisted_2),
    (_openBlock(), _createBlock(_Teleport, {
      disabled: !_ctx.moveToBody,
      to: "body"
    }, [
      (_ctx.enableMenu && _ctx.showMenu)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref: "contextMenu",
            class: "fmenu",
            style: _normalizeStyle(`left: ${_ctx.menuLeft}; top: ${_ctx.menuTop}; right: ${_ctx.menuRight}; bottom: ${_ctx.menuBottom}; width: min(max-content, ${_ctx.maxWidth}); max-width: ${_ctx.maxWidth}; height: ${_ctx.maxHeight}; max-height: ${_ctx.maxHeight}; overflow: hidden;${_ctx.menuZIndex ? ' z-index: ' + _ctx.menuZIndex + ';' : ''}`),
            tabindex: "-1",
            onBlur: _cache[0] || (_cache[0] = ($event) => _ctx.onBlur($event, true)),
            onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFmenuKeydown && _ctx.onFmenuKeydown(...args)))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "menu-content")
            ])
          ], 36))
        : _createCommentVNode("", true)
    ], 8, ["disabled"]))
  ]))
}